const overlay = {
    options: {
        stacking: {
            overMenu: 1,
            behindMenu: 2,
            overPopup: 3,
        },
        dismissable: false
    },
    showOverlay: (stacking = overlay.options.stacking.overMenu, initiator, dismissable = overlay.options.dismissable, disableScroll = true) => {
        let overlayReference = document.querySelector('.overlay');

        if (!overlayReference) {
            overlayReference = document.createElement('div');
            overlayReference.classList.add('overlay');
            overlayReference.innerHTML = '<div class="overlay--background"></div>';
            document.body.appendChild(overlayReference);
        }

        if (!overlayReference) {
            return;
        }

        overlayReference.dataset.dismissable = dismissable;

        if (overlayReference.dataset.locks) {
            if (overlayReference.dataset.locks.indexOf(initiator) === -1) {
                overlayReference.dataset.locks = overlayReference.dataset.locks + ',' + initiator
            }
        } else {
            overlayReference.dataset.locks = initiator
        }

        overlayReference.classList.add("show");
        if (disableScroll) {
            document.body.classList.add('no-scroll');
        }
        switch (stacking) {
        case overlay.options.stacking.overMenu:
            overlayReference.classList.add("overMenu");
            break;
        case overlay.options.stacking.behindMenu:
            overlayReference.classList.add("behindMenu");
            break;
        case overlay.options.stacking.overPopup:
            overlayReference.classList.add("overPopup")
            break;
        default:
            return;
        }
    },
    addEvent(type = "click", eventHandler) {
        if (document.querySelector('.overlay')) {
            document.querySelector('.overlay').addEventListener(type, eventHandler);
        }
    },
    hideOverlay: (initiator) => {
        let overlayReference = document.querySelector('.overlay');

        if (!overlayReference) {
            // Nothing to hide if there is no overlay :-)
            return;
        }

        if (!overlayReference) {
            return;
        }

        if (overlayReference.dataset.locks) {
            const locks = overlayReference.dataset.locks.split(',');
            const lockToLift = locks.indexOf(initiator);
            if (lockToLift !== -1) {
                locks.splice(lockToLift, 1);
                overlayReference.dataset.locks = locks.toString();
            }

            if (locks.length) {
                return
            }
        }

        if (overlayReference.classList.contains("overMenu")) {
            overlayReference.classList.remove("overMenu");
        }

        if (overlayReference.classList.contains("behindMenu")) {
            overlayReference.classList.remove("behindMenu");
        }

        if (overlayReference.classList.contains("overPopup")) {
            overlayReference.classList.remove("overPopup");
        }

        if (overlayReference.dataset.dismissable) {
            overlayReference.removeAttribute("data-dismissable");
        }

        if (document.body.classList.contains('no-scroll')) {
            document.body.classList.remove('no-scroll');
        }
        overlayReference.classList.remove("show");

    }
};


export { overlay }

